export default {
    baseStyle: () => ({
        container: {
            marginBottom: {base: 4},
            marginTop: {base: 6, lg: 8}
        },
        stickyContainer: {
            maxWidth: "container.xxxl",
            mx: "auto",
            padding: {base: '12px 16px', lg:  '12px 24px'}
        },
        stickyOverlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 'sticky',
            bg: 'webTheme.layerDefault',
            borderBottom: '1px solid',
            borderBottomColor: 'webBasic.200'
        },
        itemCount: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textSecondary',
            ml: 3
        },
        drawerHeader: {
            padding: {base: 4, lg: 4},
            borderColor: 'webTheme.strokeTertiary'
        },
        sfhContainer: {
            textTransform: "none"
        },
        sfhNoFilter: {
            textStyle: 'bodyXsRegular'
        },
        sfhCloseCTA: {
            height: 'auto',
            minWidth: 'auto'
        },
        srPlpContainer: {
            marginTop: {base: 6, lg: 4},
            marginBottom: {base: 4}
        },
        srContainer: {
            marginTop: 3
        },
        srRemove: {
            width: '20px',
            height: '20px'
        },
        filterLabel: {
            color: 'webTypo.textOnColor',
            textStyle: 'labelSmMd'
        },
        filterSortLabel: {
            textStyle: 'labelSmMd',
            _hover: {
                color: {base: 'webTypo.textPrimary', lg: 'webTypo.textOnColor'}
            }
        },
        srClearAllWrapper: {
            textStyle: 'labelSm'
        },
        srClearAllCTA: {
            textStyle: 'labelSm',
            minHeigh: 'auto',
            height: 'auto',
            minWidth: 'auto',
            color: 'webTypo.textSecondary',
            textDecoration: 'underline'
        },
        drawerFooter: {
            p: 4,
            borderTop: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
        }
    })
}
